import { Certificate } from 'types/Certificate';

export const filterEmptyCertificates = (certificates: Certificate[]): Certificate[] =>
  certificates.filter((cert) => Object.entries(cert).some(([key, value]) => key !== 'id' && value));
